function popupGame() {
    setTimeout(function(){
        $(".home").find(".popup-game__bg").removeClass("is-hide");
        $(".home").find(".popup-game__wrap").removeClass("is-hide");
        if($("body").hasClass("home")){
            $("body").css("overflow", "");
        }
    }, 100);
    $(".popup-game__close").on("click", function(){
        $(".home").find(".popup-game__bg").addClass("is-hide");
        $(".home").find(".popup-game__wrap").addClass("is-hide");
        $("body").css("overflow", "");
    });
}

module.exports = popupGame;
